export default "__VITE_ASSET__573810cc__"